import {Component, OnInit} from '@angular/core';
import {Repository, Structures} from "@clavisco/core";
import {environment} from "../environments/environment";
import {IToastGlobalConfiguration} from "@clavisco/alerts";
import {Login} from "@clavisco/login";
import {ITableGlobalConfiguration} from '@clavisco/table';
import * as LogRocket from 'logrocket';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'cl_cl_mlt_eag_api';
  ApiUrl=environment.ApiUrl;

  constructor() {
    if (environment.production) {
      LogRocket.init(environment.LogRocketId);
    }
  }

  ngOnInit(){
    Repository.Behavior.SetTokenConfiguration({
      token: 'Shared',
      setting: 'apiUrl',
      apiUrl: this.ApiUrl
    } as any)

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.ALERTS,
      settings: {
        duration: 8000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        cssClasses: ['alert-text']
      } as IToastGlobalConfiguration,
      override: true
    });

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.LOGN,
      setting: 'overlaysConfiguration',
      value: JSON.stringify({
        loginMessage: 'Iniciando Sesión',
        changePasswordMessage: 'Cambiando Contraseña',
        sendRecoverEmailMessage: 'Enviando Correo de Recuperación',
        recoverPasswordMessage: 'Actualizando Contraseña'
      } as Login.Structures.IOverlaysGlobalConfiguration)
    });

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.LOGN,
      setting: 'changePassword',
      value: {
        endpointToRequest: `${environment.ApiUrl}api/Users/ChangePassword`
      } as Login.Structures.IChangePasswordConfig
    })

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.LOGN,
      setting: 'recoverPassword',
      value: {
        endpointToRequest: `${environment.ApiUrl}api/Users/ChangeRecoveryPassword`
      } as Login.Structures.IChangePasswordConfig
    })

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.LOGN,
      setting: 'sendRecoverPasswordEmail',
      value: {
        urlVariableToReplaceWithEmail: '#EMAIL#',
        endpointToRequest: `${environment.ApiUrl}api/Users/#EMAIL#/RecoveryPassword`
      }
    })

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.TABL,
      settings: {
        backgroundTransparent: true
      } as ITableGlobalConfiguration
    });

    Repository.Behavior.SetTokenConfiguration({ token: 'NotificationCenter', setting: 'max', value: '10' });
  }
}
